import { ModalHeader } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'
import { WriskTrans } from '../trans'

const tKey = TKey('components.cancellation-not-allowed-modal')

export const CancellationNotAllowedModal: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  return (
    <ModalHeader
      header={t(tKey('header'))}
      subheader={<WriskTrans t={t} i18nKey={tKey('subheader')} />}
    />
  )
}
